//import logo from './logo.svg';
import { useState, useEffect, useRef, useMemo } from 'react';
import './App.css';
//import * as am5 from "@amcharts/amcharts5"
//import * as d3 from "d3";
import './GaugeChart';
import GaugeChart from './GaugeChart';
import MapChart from './MapChart';

// used to import bootstrap's css
import 'bootstrap/dist/css/bootstrap.min.css';
// used to import select dropdown
import SelectDropdown from './SelectDropdown';
import { Stack, Collapse, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Container, Row, Col } from 'react-bootstrap';
import { AnimatePresence, motion } from 'motion/react';

import { ToastContainer, toast } from "react-toastify";
// import Toast's CSS styling
import "react-toastify/dist/ReactToastify.css";

import { updateGaugeRangeAndValue } from './GaugeChart.jsx';

// import the GeoJSON files
import { manoaBuildings } from './MA_Buildings_py.js';
import { manoaBuildings2 } from './MA_Buildings2.js';

// import the building complex properties (FY 23 Data)
import EUIDataJSON from './spreadsheets/EUI Data (FY 23).json';
// import FY 24 Data
import EUIDataJSON2 from './spreadsheets/EUI Data (FY 24).json';
// import FY 25 Data
import EUIDataJSON3 from './spreadsheets/EUI Data (FY 25).json';

// import FY 23 and FY 24 data
import EUIDataJSONAll from './spreadsheets/EUI Data (FY 23).json';
// similar to EUIDataJSON but it includes more accurate information about the cooling loops each building is in
import EUICoolingLoops from './spreadsheets/EUI Data Cooling Loops.json';

// used to color the buildings based on EUI value
var EUIColors = [
    {color: "rgb(0, 255, 0)", quality: "Excellent EUI"},
    {color: "rgb(155, 255, 100)", quality: "Good EUI"},
    {color: "#FFFF00", quality: "Average EUI"},
    {color: "rgb(255, 155, 0)", quality: "Poor EUI"},
    {color: "rgb(255, 0, 0)", quality: "Very Poor EUI"},
    {color: "rgb(200, 0, 0)", quality: "Extremely Poor EUI!"},
    {color: "rgb(0, 0, 0)", quality: "Unknown EUI"},
    {color: "#806A5C", quality: "No EUI"},
];

// // get a list of complex names from the JSON file, then sort the names in alphabetical order
// var complexNames = complexNamesData
//     .map(building => (building['Building Complex Name']))
//     .sort();

// .map(building => (building['Group'] === '' || building['Group'] === 'Cooling Loop B') ? building['Building Complex Name'] : building['Group'])

var boolie = true;

// remove duplicate cooling loops
var complexNamesList;

var countie = 0;

// used to implement building complex data (including individual building shapes) into a new GeoJSON file
function adjustBuildingData(infoRef, theEUIData, buildingsData) {
    // update dataset as a new one (used to add more properties)
    let includedBuildings = {
        "type": "FeatureCollection",
        "features": [] // stores individual buildings
    };

    
    //let euiData = theFiscalYear === 2023 ? EUIDataJSON : EUIDataJSON2;
    //console.log(euiData);

        // push the buildings that are included in the data set
        for (let i = 0; i < theEUIData?.length; i++) {
            
                // if (theFiscalYear === 2023) {
                //     if (EUIDataJSONAll[i]['Fiscal Year'] !== 2023)  {
                //         console.log("hay");
                //         break;
                //     }
                // } 

                // if (theFiscalYear === 2024 || theFiscalYear === 2025) {
                //     //
                //     if (EUIDataJSONAll[i]['Fiscal Year'] !== 2024)  {
                //         console.log(theFiscalYear);
                //         // // infinite loop
                //         continue;
                //     }
                // }
            // used to loop again since two JSON files have buildings in different order
            for (let j = 0; j < buildingsData?.features.length; j++) {
                // a list to store all the building names in a complex or cooling loop
                //manoaBuildings.features[j].properties.buildingsList = [];

                
                // if (theFiscalYear === 2024 || theFiscalYear === 2025) {
                //     //console.log(theFiscalYear);
                //     if (EUIDataJSONAll[i]['Fiscal Year'] !== 2024)  {
                //         // // infinite loop
                //         continue;
                //     }
                // }

                if (theEUIData[i]['Building Complex Name'] === buildingsData.features[j].properties.COMPLEX_NAME) {

                    // console.log("pls work");

                    // get the building's cooling loop and add a new property to the other JSON
                    buildingsData.features[j].properties.COOLING_LOOP = theEUIData[i]["Cooling Loop"];

                    
                    // convert string to number b/c EUI is initially string data type, toFixed rounds to the nearest 2 decimal places (hundredth)
                    buildingsData.features[j].properties.euiValue = (theEUIData[i]["Cooling Loop EUI"] === "" || theEUIData[i]["Cooling Loop EUI"] === undefined) ? Number(theEUIData[i]["EUI"]).toFixed(2) : Number(theEUIData[i]["Cooling Loop EUI"]).toFixed(2);
                    // store it in the other JSON since both JSONs contain separate data
                    buildingsData.features[j].properties.maxEUIValue = Number(theEUIData[i]["Average Expected EUI"] * 2);
                    // get the building type and add a new property to the other JSON
                    buildingsData.features[j].properties.buildingType = theEUIData[i]["Spatial Usage Type"];

                    //manoaBuildings.features[j].properties.buildingsList.push(manoaBuildings.features[j].properties.PROPER_NAME);
                    

                    // used to store the quality reference (will be determined when the user clicks on a building on the map chart)
                    buildingsData.features[j].properties.EUI_QUALITY = "";

                    let sectionColor;
                    let getEUIValue = buildingsData.features[j].properties.euiValue;
                    let getMaxEUIValue = buildingsData.features[j].properties.maxEUIValue;
                    let getQuality = buildingsData.features[j].properties.EUI_QUALITY = "";
                    
                    // first test case is for buildings with no EUI data
                    if (getEUIValue < 0) {
                        if (getMaxEUIValue > 0) {
                            sectionColor = EUIColors[6];
                            getQuality = "Unknown EUI";
                            // console.log("unknown detected!");
                        } else {
                            sectionColor = EUIColors[7];
                            getQuality = "No EUI";
                        }
                        //console.log(getMaxEUIValue);
                    } else if (getEUIValue / getMaxEUIValue < 0.2) {
                        // green if the EUI value is very low
                        sectionColor = EUIColors[0]; 
                        getQuality = "Excellent EUI";
                    } else if (getEUIValue / getMaxEUIValue < 0.4) {
                        // light green if the EUI value is low
                        sectionColor = EUIColors[1];
                        getQuality = "Good EUI";
                    } else if (getEUIValue / getMaxEUIValue < 0.6) {
                        // yellow if the EUI value is medium
                        sectionColor = EUIColors[2];
                        getQuality = "Average EUI";
                    } else if (getEUIValue / getMaxEUIValue < 0.8) {
                        // orange if the EUI value is high
                        sectionColor = EUIColors[3];
                        getQuality = "Poor EUI";
                    } else if (getEUIValue / getMaxEUIValue <= 1) {
                        // red if the EUI value is very high
                        sectionColor = EUIColors[4];
                        getQuality = "Very Poor EUI";
                    } else {
                        // darker red if the EUI value is off the charts!
                        sectionColor = EUIColors[5];
                        getQuality = "Extremely Poor EUI!";
                    } 
                    buildingsData.features[j].properties.EUI_QUALITY = sectionColor.quality;
                    buildingsData.features[j].properties.EUI_COLOR = sectionColor.color;
                    // console.log(buildingsData.features[j].properties.EUI_COLOR);

                    // used to update the gauge chart via changing the fiscal year
                    if (infoRef && infoRef[2].current === manoaBuildings.features[j].properties.COMPLEX_NAME) {
                        
                        infoRef[0].current = buildingsData.features[j].properties.maxEUIValue;
                        infoRef[1].current = Number(buildingsData.features[j].properties.euiValue);
                        infoRef[2].current = buildingsData.features[j].properties.COMPLEX_NAME;
                        infoRef[3].current = buildingsData.features[j].properties.EUI_QUALITY;
                        infoRef[4].current = buildingsData.features[j].properties.buildingType;
                        infoRef[5].current = buildingsData.features[j].properties.COOLING_LOOP;
                        console.log(infoRef[0].current, infoRef[1].current, infoRef[2].current, infoRef[3].current, infoRef[4].current, infoRef[5].current);
                        
                        // used setTimeout to prevent "flicker" of the gauge needle (smaller the time value, the less noticeable the flicker is)
                        setTimeout(() => {
                            updateGaugeRangeAndValue(infoRef[0].current, infoRef[1].current, infoRef[2].current, infoRef[3].current, infoRef[4].current, infoRef[5].current);
                        }, 1000);
                    }

                    // used so that magoon research facility doesn't switch to small animal care facility when switching from 2023 to 2024
                    if (infoRef && infoRef[2].current === "SMALL ANIMAL CARE FACILITY") {
                        infoRef[0].current = 44.4;
                        infoRef[1].current = 3.92;
                        infoRef[2].current = "MAGOON RESEARCH FACILITY";
                        infoRef[3].current = "Excellent EUI";
                        infoRef[4].current = "Greenhouse and Science";
                        infoRef[5].current = "";
                    }

                    //prevColors?.set(manoaBuildings2.features[j].properties.COMPLEX_NAME, sectionColor.color);

                    // push building to a new GeoJSON
                    includedBuildings.features.push(buildingsData.features[j]);
                }
            }   
        }
    
    // returns one geojson object
    return includedBuildings;
}

// used so the building data doesn't become null on first render
function initializeBuildingData() {
  let prevColors = new Map();

  // push the buildings that are included in the data set
        for (let i = 0; i < EUIDataJSON.length; i++) {
            // used to loop again since two JSON files have buildings in different order
            for (let j = 0; j < manoaBuildings.features.length; j++) {
                // a list to store all the building names in a complex or cooling loop
                //manoaBuildings.features[j].properties.buildingsList = [];

                if (EUIDataJSON[i]['Building Complex Name'] === manoaBuildings.features[j].properties.COMPLEX_NAME) {
                    // get the building's cooling loop and add a new property to the other JSON
                    // manoaBuildings.features[j].properties.COOLING_LOOP = EUICoolingLoops[i]["Group"];

                    // let theCoolingLoop = manoaBuildings.features[j].properties.COOLING_LOOP;
                    // if (theCoolingLoop !== "" && theCoolingLoop !== "B") {
                    //     manoaBuildings.features[j].properties.euiValue = Number(EUICoolingLoops[i]['EUI']);
                    //     manoaBuildings.features[j].properties.maxEUIValue = Number(EUICoolingLoops[i]['Average Expected EUI']) * 2;
                    //     manoaBuildings.features[j].properties.buildingType = EUICoolingLoops[i]['Spatial Usage Type'];

                    //     //manoaBuildings.features[j].properties.buildingsList.push(manoaBuildings.features[j].properties.COMPLEX_NAME);
                    //     //console.log(manoaBuildings.features[j].euiValue + " " + manoaBuildings.features[j].maxEUIValue);
                    // } else {
                        // convert string to number b/c EUI is initially string data type
                        manoaBuildings.features[j].properties.euiValue = Number(EUIDataJSON[i]['EUI']).toFixed(2);
                        // store it in the other JSON since both JSONs contain separate data
                        manoaBuildings.features[j].properties.maxEUIValue = Number(EUIDataJSON[i]['Average Expected EUI']) * 2;
                        // get the building type and add a new property to the other JSON
                        manoaBuildings.features[j].properties.buildingType = EUIDataJSON[i]["Spatial Usage Type"];

                    //     //manoaBuildings.features[j].properties.buildingsList.push(manoaBuildings.features[j].properties.PROPER_NAME);
                    // }

                    // used to store the quality reference (will be determined when the user clicks on a building on the map chart)
                    //manoaBuildings.features[j].properties.EUI_QUALITY = "";

                    let sectionColor;
                    let getEUIValue = manoaBuildings.features[j].properties.euiValue;
                    let getMaxEUIValue = manoaBuildings.features[j].properties.maxEUIValue;
                    //console.log(getEUIValue, getMaxEUIValue);
                    
                    // first test case is for buildings with no EUI data
                    if (getEUIValue < 0) {
                        sectionColor = (getMaxEUIValue > 0) ? EUIColors[6] : EUIColors[7];
                        //console.log(getMaxEUIValue);
                    } else if (getEUIValue / getMaxEUIValue < 0.2) {
                        // green if the EUI value is very low
                        sectionColor = EUIColors[0]; 
                        
                    } else if (getEUIValue / getMaxEUIValue < 0.4) {
                        // light green if the EUI value is low
                        sectionColor = EUIColors[1];
                    } else if (getEUIValue / getMaxEUIValue < 0.6) {
                        // yellow if the EUI value is medium
                        sectionColor = EUIColors[2];
                    } else if (getEUIValue / getMaxEUIValue < 0.8) {
                        // orange if the EUI value is high
                        sectionColor = EUIColors[3];
                    } else if (getEUIValue / getMaxEUIValue <= 1) {
                        // red if the EUI value is very high
                        sectionColor = EUIColors[4];
                    } else {
                        // darker red if the EUI value is off the charts!
                        sectionColor = EUIColors[5];
                    } 
                    manoaBuildings.features[j].properties.EUI_QUALITY = sectionColor.quality;
                    manoaBuildings.features[j].properties.EUI_COLOR = sectionColor.color;
                    // console.log(manoaBuildings.features[j].properties.EUI_COLOR);
                    // if (manoaBuildings.features[j].properties.COMPLEX_NAME === "CASTLE MEMORIAL CARETAKERS COTTAGE")  console.log(manoaBuildings.features[j].properties.COMPLEX_NAME, manoaBuildings.features[j].properties.EUI_QUALITY, manoaBuildings.features[j].properties.EUI_COLOR);

                    // if (infoRef) {
                    //     infoRef[0].current.push(manoaBuildings.features[j].properties.maxEUIValue);
                    //     infoRef[1].current.push(manoaBuildings.features[j].properties.euiValue);
                    //     infoRef[2].current.push(manoaBuildings.features[j].properties.COMPLEX_NAME);
                    //     infoRef[3].current.push(manoaBuildings.features[j].properties.EUI_QUALITY);
                    //     infoRef[4].current.push(manoaBuildings.features[j].properties.buildingType);
                    //     infoRef[5].current.push(manoaBuildings.features[j].properties.COOLING_LOOP);

                        
                    // }
                    
                    prevColors.set(manoaBuildings.features[j].properties.COMPLEX_NAME, manoaBuildings.features[j].properties.EUI_COLOR);

                    // push building to a new GeoJSON
                    //includedBuildings.features.push(manoaBuildings.features[j]);
                }
            }   
        }
        return prevColors;
}

// groups the polygon shapes by building complex name
function groupByComplexName(features) {
    // reduce takes in the result name and object name, {} represents the initial result (calculates ALL the features)
    return features.reduce((complexNames, feature) => {
        // get the building complex name (group by cooling loop if a building is part of one, ignore B Loop b/c one of its buildings have an Unknown EUI value)
        let complexName = feature.properties.COMPLEX_NAME
        //feature.properties.EUI = EUICoolingLoops
        // if complex name isn't in the array, create an array for all polygons belonging to the same complex name
        if (!complexNames[complexName]) complexNames[complexName] = [];
        // add a polygon to the complex name group
        complexNames[complexName].push(feature);
        
        //console.log(Object.keys(complexNames).length); // 127 complex names total
        //console.log(complexNames);
        
        // returns an object with keys (complex names) that contains the polygon feature(s) 
        return complexNames;
    }, {});
}

// calls groupByComplexName before combining polygon shapes (needs to know which group each polygon falls into before combining them)
function combinePolygonsByName(geojson) {
    // create building groups for the building shapes
    let buildingGroups = groupByComplexName(geojson.features);
    // console.log(buildingGroups);
    //buildingGroups
    // creates a new array of objects by combining multiple polygons for each complex name
    let combinedPolygons = Object.keys(buildingGroups).map(name => {
        // buildingGroups.
        // gets an array of features based on the complex name
         let polygonFeatures = buildingGroups[name];
         //let buildingNamesArr = (polygonFeatures[0].properties.COOLING_LOOP === "" || polygonFeatures[0].properties.COOLING_LOOP === "B loop") ? polygonFeatures.map(f => f.properties.PROPER_NAME).sort() : [...new Set(polygonFeatures.map(f => f.properties.COMPLEX_NAME))];
         //console.log(polygonFeatures);
         // Collect all the polygons' coordinates directly and combines them 
         let combinedCoordinates = polygonFeatures.reduce((acc, feature) => { 
            if (feature.geometry.type === "MultiPolygon") {
                // separate the polygons from the existing multipolygon then combine them into acc
                acc.push(feature.geometry.coordinates.flat());
            } else {
                // push polygon coordinates into a coordinates array
                acc.push(feature.geometry.coordinates);
            }
            return acc; 
        }, []);

        //let polygonType = polygonFeatures.length == 1 && polygonFeatures[0].properties.COMPLEX_NAME ? "Polygon" : "MultiPolygon";

        // returns a MultiPolygon Feature
         return {
            // use the spread operator to retain the existing properties for each feature
            ...polygonFeatures[0], // there's only one combined polygon feature for each complex name
            geometry: {
                // MultiPolygon is used to avoid line connecting to all polygons
                type: "MultiPolygon", 
                coordinates: combinedCoordinates // .coordinates gets the existing polygon coordinates
            },
            //names: buildingNamesArr
         };
    });

    // sort the polygons by complex name in alphabetical order
    const sortedPolygons = [...combinedPolygons].sort((a, b) =>
  (a.properties?.COMPLEX_NAME || '').localeCompare(b.properties?.COMPLEX_NAME || '')
);


    // returns new GeoJSON object
    return {
        type: 'FeatureCollection',
        features: sortedPolygons
    };
}



// imported some stuff that were from gauge and map chart to main in order to have more control

function App() {
  //const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredOptions, setFilteredOptions] = useState([]);
  // use isCooldown for both Map and Gauge charts
  const [isCooldown, setIsCooldown] = useState(false);
  const [isCooldown2, setIsCooldown2] = useState(false);
  // fiscal year
  const [fiscalYear, setFiscalYear] = useState(2023);
  const [isOpen, setIsOpen] = useState(false);

  const previousFiscalYear = useRef(2023);

  const [toastShown2, setToastShown2] = useState(false);

  const [euiData, setEUIData] = useState(EUIDataJSON)
  const [includedBuildings, setIncludedBuildings] = useState(adjustBuildingData(fiscalYear));
  const [combinedBuildingsData, setCombinedBuildingsData] = useState(combinePolygonsByName(includedBuildings));

  const isCooldownRef = useRef(isCooldown);
  const filterOptionsRef = useRef(null);
  const dropdownRef = useRef(null);
  const buildingInfoRefs = Array.from({ length: 6 }, () => useRef(null));

  const previousColorsRef = useRef(initializeBuildingData());
  //console.log(previousColorsRef.current);
  const selectedBuildingRef = useRef(null);
  const previouslySelectedBuildingRef = useRef(null);

  const polylineRef1 = useRef([]);
  const polylineRef2 = useRef([]);
  const polylineRef3 = useRef([]);
  const polylineRef4 = useRef([]);
  const polylineRef5 = useRef([]);

  // used to allow one updateValue function at a time?
  const boolzRef = useRef(false);

  // const [isExcellentEUI, setIsExcellentEUI] = useState(false);
  // const [isGoodEUI, setIsGoodEUI] = useState(false);
  // const [isAverageEUI, setIsAverageEUI] = useState(false);
  // const [isPoorEUI, setIsPoorEUI] = useState(false);
  // const [isVeryPoorEUI, setIsVeryPoorEUI] = useState(false);
  // const [isExtremelyPoorEUI, setIsExtremelyPoorEUI] = useState(false);
  // const [isUnknownEUI, setIsUnknownEUI] = useState(false);
  // const [isNoEUI, setIsNoEUI] = useState(false);

  // const [isLoopA, setIsLoopA] = useState(false);
  // const [isLoopB, setIsLoopB] = useState(false);
  // const [isLoopC, setIsLoopC] = useState(false);
  // const [isLoopD, setIsLoopD] = useState(false);
  // const [isLoopQUAD, setIsLoopQUAD] = useState(false);

  // const setEUIStates = [setIsExcellentEUI, setIsGoodEUI, setIsAverageEUI, setIsPoorEUI, setIsVeryPoorEUI, setIsExtremelyPoorEUI, setIsUnknownEUI, setIsNoEUI];
  // const euiStates = [isExcellentEUI, isGoodEUI, isAverageEUI, isPoorEUI, isVeryPoorEUI, isExtremelyPoorEUI, isUnknownEUI, isNoEUI];
  // const setLoopStates = [setIsLoopA, setIsLoopB, setIsLoopC, setIsLoopD, setIsLoopQUAD];
  // const loopStates = [isLoopA, isLoopB, isLoopC, isLoopD, isLoopQUAD];

  const previousVisibility = useRef(new Map());

  const euiLabels = [
        "Excellent EUI",
        "Good EUI",
        "Average EUI",
        "Poor EUI",
        "Very Poor EUI",
        "Extremely Poor EUI!",
        "Unknown EUI",
        "No EUI",
    ];
    
const resetToOpaque = (group) => {
        group.forEach((path) => {
            path.classList.remove("building-dimmed");
            path.classList.add("building-visible");
        }); 
    };

  useEffect(() => {
    //var jsonData = fiscalYear === 2023 ? EUIDataJSON : EUIDataJSON2;
    var complexNamesData = fiscalYear === 2023 ? EUIDataJSON : fiscalYear === 2024 ? EUIDataJSON2 : EUIDataJSON3;
    var buildingShapesData = fiscalYear === 2023 ? manoaBuildings : manoaBuildings2;

    // get a list of complex names from the JSON file, then sort the names in alphabetical order
    var complexNames = complexNamesData
        .map(building => (building['Building Complex Name']))
        .sort();
        // remove duplicate cooling loops
        complexNamesList = [...new Set(complexNames)];

    setEUIData(complexNamesData);

        // update building data (via fiscal year)
        const updated = adjustBuildingData(buildingInfoRefs, complexNamesData, buildingShapesData);
        setIncludedBuildings(updated);
        setCombinedBuildingsData(combinePolygonsByName(updated));
        console.log(combinedBuildingsData.features.length);

        //updateGaugeRangeAndValue(buildingInfoRefs[0].current, buildingInfoRefs[1].current, buildingInfoRefs[2].current, buildingInfoRefs[3].current, buildingInfoRefs[4].current, buildingInfoRefs[5].current);

        // polylineRef1.current = [];
        // polylineRef2.current = [];
        // polylineRef3.current = [];
        // polylineRef4.current = [];
        // polylineRef5.current = [];

        // used so that the cooling loops can revert back to their default opacity every time the year changes
        // used ? to ensure classList doesn't execute when the ref is null
        resetToOpaque(polylineRef1.current);
        resetToOpaque(polylineRef2.current);
        resetToOpaque(polylineRef3.current);
        resetToOpaque(polylineRef4.current);
        resetToOpaque(polylineRef5.current);

        previousVisibility.current = new Map();
      }, [fiscalYear]);

  

  // filters options based on the dropdown (toLowerCase as an alternative to ignoreEqualsCase)
      useEffect(() => {
          const filtered = complexNamesList.filter(option =>
              option.toLowerCase().includes(searchTerm.toLowerCase())
          );
          //setFilteredOptions(filtered); // ✅ Keeps dropdown & map updated
          filterOptionsRef.current = filtered; // store previous filter options data
          setFilteredOptions(filterOptionsRef.current);
          //selectedBuildingRef.current = filtered.length === 1 ? filtered[0] : null; // remove cus it can reset to null
      }, [searchTerm, complexNamesList, fiscalYear]); // ✅ Ensures updates when `searchTerm` changes

    // used when the user clicks away from the search bar
    function handleClickOutside(event) {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
    }

useEffect(() => {
        //if (visible)    dropdownRef.current.click();
        // add a mousedown event listener that triggers the handleClickOutside function
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            // removes the event listener to prevent memory leaks from useEffect
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // [visible] event listener updates based on the visible variable
    }, [isOpen]);

      // used to update cooldown
      useEffect(() => {
        isCooldownRef.current = isCooldown;
      }, [isCooldown]);

  const isMobile = useIsMobile();
  const isTablet = useIsMobile(1485);

  return (
    <Container fluid className="App">
      {/* If desktop/tablet, then only top padding gets affected.  If mobile, then all padding get affected */}
      <Row style={{padding: isMobile ? "1rem" : "1rem 0rem 0rem 0rem"}}>
      <Col  className="p-0" style={{textAlign: "center", marginTop: "-1rem", marginBottom: isMobile ? "1rem" : "0rem"}}>
      <h1 className="headerInfo" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', marginBottom: '-36px', color: 'rgb(0, 77, 62)' }}>
        {isMobile ? "FY" : "Fiscal Year" }
        <Dropdown ref={dropdownRef} style={{ display: 'inline-block', position: 'relative' }} onClick={() => setIsOpen(!isOpen)}>
          <DropdownToggle variant="link" style={{fontSize: 'inherit', padding: 0}} 
          onClick={() => {
            
              setIsOpen(!isOpen);
            
          }}>
            {fiscalYear}
          </DropdownToggle>
          {/* apparently, you need both maxWidth: 100% AND minWidth: auto to remove excessive whitespace (makes sense since it needs bounds to know the width limit) */}
          
<AnimatePresence>
  {isOpen && (
    <motion.div
      
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
      style={{
        position: 'absolute',
        maxWidth: '220px',
        width: '100%',
        backgroundColor: 'white',
        border: '1px solid #ccc',
        borderRadius: '4px',
        zIndex: 2000,
        // overflow: 'hidden',
      }}
    >
  {[2023, 2024, 2025].map((year) => (
    <div
      key={year}
      onClick={() => { 
        

        if (isCooldown2) {
              if (!toastShown2) {
                console.log("please show up");
                toast.warn(<>Please wait a little.</>, 
                                { 
                                    position: 'top-center',
                                    autoClose: 1000, 
                                    onClose: () => {
                                        setToastShown2(false);
                                    }
                                });
                                // toast shown status is set to true, false 1 second after it shows up
                                setToastShown2(true);
                            
                            return;
              }
            } else {
              setFiscalYear(year);
              setIsOpen(false); 
              
              setIsCooldown2(true);
              setToastShown2(false);
            }
            
            

            setTimeout(() => {
              setIsCooldown2(false);
              setToastShown2(false);
            }, 4000);
        //updateGaugeRangeAndValue(buildingInfoRefs[0].current, buildingInfoRefs[1].current, buildingInfoRefs[2].current, buildingInfoRefs[3].current, buildingInfoRefs[4].current, buildingInfoRefs[5].current);
      }}
      style={{
        width: '100%',
        padding: '0.5rem 1rem',
        cursor: 'pointer',
        display: 'block',
        transition: 'background 0.2s',
      }}
      className="custom-dropdown-item"
    >
      {year}
    </div>
  ))}
</motion.div>

  )}
</AnimatePresence>


          
          
        </Dropdown> 
        {isMobile || isTablet ? "UH Manoa EUI Map" : "University of Hawaii at Manoa Energy Usage Intensity (EUI) Map"}
      </h1>
      </Col>
      </Row>
      <Container fluid className="AppFlex" >
        {/* need g-0 for better layout */}
        <Row className="g-0">
        {/* <div style={{width: "50%"}}></div> */}
        {/* <div style={{borderStyle: "solid", maxHeight: "86vh", borderColor: 'rgb(0, 77, 62)', backgroundColor: 'white'}}>
          <div style={{borderStyle: "none none solid none", textAlign: "left", borderColor: 'rgb(0, 77, 62)'}}> */}
          <Col xs={12} md={5} className="order-1 order-md-2 mobile-section tablet-section p-0" style={{display: "flex", flexDirection: "column", borderStyle: "solid", height: "86vh", borderColor: 'rgb(0, 77, 62)', paddingLeft: "0rem", backgroundColor: 'white', position: "relative", zIndex: 2
}}>
             <Col className="p-0" style={{borderStyle: "none none solid none", textAlign: "left", width: "100%", borderColor: 'rgb(0, 77, 62)', flex: "0 0 auto"}}>
              <SelectDropdown searchTerm={searchTerm} setSearchTerm={setSearchTerm} filteredOptions={filteredOptions} setFilteredOptions={setFilteredOptions} selectedBuildingRef={selectedBuildingRef} />
             </Col>
             <Col className="p-0" style={{ flex: "1 1 auto", overflowY: "hidden" }}>
              <GaugeChart isCooldown={isCooldown} setIsCooldown={setIsCooldown} toastShown2={toastShown2} setToastShown2={setToastShown2} fiscalYear={fiscalYear} previousFiscalYear={previousFiscalYear} />
             </Col>
              
          </Col>  
             
            
          {/* </div> */}
        {/* </div> */}
          <Col xs={12} md={7} className="order-2 order-md-1 mobile-section p-0"  style={{height: "86vh", paddingLeft: "0.01rem", overflow: "hidden"}}>
            <MapChart filteredOptions={filteredOptions} setFilteredOptions={setFilteredOptions} fiscalYear={fiscalYear} filterOptionsRef={filterOptionsRef} combinedBuildingsData={combinedBuildingsData} isCooldown={isCooldown} isCooldownRef={isCooldownRef} polylineRef1={polylineRef1} polylineRef2={polylineRef2} polylineRef3={polylineRef3} polylineRef4={polylineRef4} polylineRef5={polylineRef5} searchTerm={searchTerm} setSearchTerm={setSearchTerm} buildingInfoRefs={buildingInfoRefs} previousColorsRef={previousColorsRef} selectedBuildingRef={selectedBuildingRef} previousVisibility={previousVisibility} previouslySelectedBuildingRef={previouslySelectedBuildingRef}
              getColorForBuilding={(quality) => {
                //const dataset = fiscalYear === 2023 ? EUIDataJSON : fiscalYear === 2024 ? EUIDataJSON2 : EUIDataJSON3;
                //const buildingData = combinedBuildingsData.features.find(b => b.properties.COMPLEX_NAME === buildingName);
                //const quality = buildingData?.EUI_QUALITY;
                //console.log(buildingData);
                switch (quality) {
                  case "Excellent EUI":
                    return "rgb(0, 255, 0)";
                  case "Good EUI":
                    return "rgb(155, 255, 100)";
                  case "Average EUI":
                    return "#FFFF00";
                  case "Poor EUI":
                    return "rgb(255, 155, 0)";
                  case "Very Poor EUI":
                    return "rgb(255, 0, 0)";
                  case "Extremely Poor EUI!":
                    return "rgb(200, 0, 0)";
                  case "No EUI":
                    return "#806A5C";
                  default:
                    return "rgb(0, 0, 0)"; // Unknown EUI or any other case
                }
              }}
              />
          </Col>
        </Row>
      </Container>
      <div className="footerInfo" style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
        <span style={{marginTop: "-1.5%", whiteSpace: "normal"}}>EUI = Energy Usage Intensity, Cooling loop = An air conditioner system for buildings</span>
      </div>
       
           
    </Container>
  );
}

// used to determine if the user is on a mobile device (for responsive design), especially for the h1 and the dropdown menu
function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);
  return isMobile;
}

// If you render the same component multiple times, each will get its own state.
// in other words, each button has a separate counter (that doesn't affect the other)

export default App;

/* <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          React is so darn cool!
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header> */